import CustomButton from "components/Atoms/CustomButton"
import CustomButtonGroup from "components/Atoms/CustomButtonGroup"
import CustomDateInput from "components/Atoms/CustomDateInput"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import dayjs from "dayjs"
import React from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import FundFlowActions from "./FundFlowActions"
import FundFlowFilter from "./FundFlowFilter"

const FundFlowHeader = () => {
  const [params, setParams] = useSearchParams()
  const search = params.get("search")
  const date = params.get("date") || dayjs().format("YYYY-MM-DD")
  const location = useLocation()
  const navigate = useNavigate()
  const activeTab =
    location.pathname === "/d/ecom/fund-flow" ? "dashboard" : "transactions"

  return (
    <ModuleHeader
      filter={activeTab === "transactions" && <FundFlowFilter />}
      white={true}
      borderBottom="none"
      header={
        <div className="flex items-center">
          <Description icon="send-to" title="Fund Flow" />
          <CustomButtonGroup joint className="ml-3">
            <CustomButton
              intent={activeTab === "dashboard" ? "primary" : null}
              icon={activeTab === "dashboard" ? "th" : null}
              text="Dashboard"
              onClick={() => navigate("/d/ecom/fund-flow?date=" + date)}
            />
            <CustomButton
              intent={activeTab === "transactions" ? "primary" : null}
              icon={activeTab === "transactions" ? "th" : null}
              text="Transactions"
              onClick={() =>
                navigate("/d/ecom/fund-flow/transactions?date=" + date)
              }
            />
          </CustomButtonGroup>
        </div>
      }
      query={search}
      onQueryChange={query => {
        params.set("search", query)
        params.set("page", "0")
        setParams(params)
      }}
    >
      <FundFlowActions className="mr-3" />
      <CustomDateInput
        value={date}
        className="mb-0"
        big={false}
        shortcuts={true}
        onChange={(_, value) => {
          params.set("date", value)
          params.set("page", "0")
          params.set("search", "")
          setParams(params)
        }}
      />
    </ModuleHeader>
  )
}

export default FundFlowHeader
